import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IMisDeliveryResponse } from "../models";
import { throwApiError } from "./apiError";
import { getTrackingHeadersMap } from "./getTrackingHeaders";

/**
 * GET API call using Axios
 * @returns - Array of Exception List of type IMisDeliveryResponse[]
 */

export const getMisDelivery = async (osdId: string): Promise<IMisDeliveryResponse> => {
  try {
    const headers = getTrackingHeadersMap(ApiType.GET_MISDELIVERY);
    headers["OSD-Exception-Number"] = osdId; // Add dynamic OSD-Exception-Number header 
    const response = await axios.get(`${getUrl(ApiType.MSD_VIEW)}/${osdId}`, { headers });
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.misDelivery);
  }
};
